import gql from "graphql-tag";
import FinancialsTemplateFieldsFragment from "components/financials/modern/graphql/fragments/FinancialsTemplateFieldsFragment";

export default gql`
  query Nodes($ids: [ID!]!) {
    nodes(ids: $ids) {
      ... on Node {
        id
      }
      ... on FinancialsTemplate {
        id
        ...FinancialsTemplateFields
      }
    }
  }
  ${FinancialsTemplateFieldsFragment}
`;
